import React, { useEffect, useMemo, useState } from "react";
import '../../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link, useParams, useLocation } from "react-router-dom"; 

// Import service
import {
  fetchPaketDetailTryout,
  createPaketDetailTryout,
  updatePaketDetailTryout,
  deletePaketDetailTryout,
} from '../../../../services/Master/PaketTryoutDetail';
import { fetchJenisSoal } from '../../../../services/Master/MasterJenisSoal'; // Pastikan path benar

// Import komponen umum
import Breadcrumbs from '../../../../components/Common/Breadcrumb';
import DeleteModal from '../../../../components/Common/DeleteModal';

const PaketDetailTryout = () => {
  document.title = "Master Paket Detail Tryout";

  const { id_paket: idPaketFromUrlParam } = useParams(); 
  const location = useLocation(); 

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  
  // Ambil parameter dari URL dan langsung konversi ke integer
  const idPaket = queryParams.get('id_paket') ? parseInt(queryParams.get('id_paket'), 10) : null;
  const idTipeKonten = queryParams.get('id_tipe_konten') ? parseInt(queryParams.get('id_tipe_konten'), 10) : null;
  const idJenisSeleksi = queryParams.get('id_jenis_seleksi') ? parseInt(queryParams.get('id_jenis_seleksi'), 10) : null;
  
  // --- DEBUGGING SANGAT PENTING ---
  console.log("DEBUG: Component Mounted/Updated");
  console.log("DEBUG: Path parameter id_paket:", idPaketFromUrlParam); // Harusnya string '27'
  console.log("DEBUG: Full URL:", location.pathname + location.search); // Pastikan ini menampilkan URL lengkap dengan query params
  console.log("DEBUG: Parsed id_tipe_konten:", idTipeKonten, typeof idTipeKonten); // Harusnya number 6
  console.log("DEBUG: Parsed id_jenis_seleksi:", idJenisSeleksi, typeof idJenisSeleksi); // Harusnya number 44
  // --- AKHIR DEBUGGING ---

  // State management
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [paketDetailTryout, setPaketDetailTryout] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingJenisSoalOptions, setLoadingJenisSoalOptions] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [filters, setFilters] = useState({
    id_paket: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [jenisSoalOptions, setJenisSoalOptions] = useState([]);

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPaketDetailTryout(null);
  };

  const handleConfirmDelete = async () => {
    try {
      if (paketDetailTryout && paketDetailTryout.id_detail_tryout) {
        const response = await deletePaketDetailTryout(paketDetailTryout.id_detail_tryout);
        if (response.success) {
          toast.success("Detail Paket Tryout berhasil dihapus");
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Gagal menghapus Detail Paket Tryout");
        }
      }
    } catch (error) {
      console.error("Error deleting Paket Detail Tryout:", error);
      toast.error(error.message || "Gagal menghapus Detail Paket Tryout");
    } finally {
      handleCloseDeleteModal();
    }
  };

  const fetchData = async (page = 1, per_page = 10, filterParams = {}) => {
    try {
      setLoading(true);
      if (!idPaket) {
        setLoading(false);
        toast.error("ID Paket tidak ditemukan di URL. Silakan kembali ke halaman master paket.");
        return;
      }

      const combinedFilters = { ...filterParams, id_paket: idPaket };

      const response = await fetchPaketDetailTryout({
        page,
        per_page,
        filters: combinedFilters,
      });

      setData(response.data || []);
      setPagination({
        page: response.meta?.page || 1,
        per_page: response.meta?.per_page || 10,
        total: response.meta?.total || 0,
        last_page: response.meta?.last_page || Math.ceil((response.meta?.total || 0) / (response.meta?.per_page || 10))
      });
    } catch (error) {
      console.error("Error in fetchData:", error);
      if (error.response) {
        toast.error(error.response.data.message || "Gagal memuat data Detail Paket Tryout.");
      } else {
        toast.error("Terjadi kesalahan jaringan atau server tidak merespons.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk memuat opsi jenis soal dengan filter
  const fetchJenisSoalOptions = async (tipeKontenId, jenisSeleksiId) => {
    try {
      setLoadingJenisSoalOptions(true);
      const params = { disable_pagination: true };
      console.log(idJenisSeleksi)
      // Tambahkan filter hanya jika ID tersedia dan valid (bukan null atau NaN)
      if (tipeKontenId) { // Mengecek bukan null, 0, atau undefined
        params.id_tipe_konten = tipeKontenId;
      }
      if (jenisSeleksiId) { // Mengecek bukan null, 0, atau undefined
        params.id_jenis_seleksi = jenisSeleksiId;
      }

      // --- DEBUGGING UNTUK PANGGILAN SERVICE ---
      console.log("DEBUG: Calling fetchJenisSoal with params:", params);
      // --- AKHIR DEBUGGING ---

      const response = await fetchJenisSoal(params); // Teruskan params ke service
      if (response && response.data) {
        setJenisSoalOptions(response.data);
      } else {
        toast.error("Gagal memuat opsi jenis soal: struktur respons tidak valid");
      }
    } catch (error) {
      console.error("Error fetching jenis soal options:", error);
      toast.error("Terjadi kesalahan saat memuat opsi jenis soal.");
    } finally {
      setLoadingJenisSoalOptions(false);
    }
  };

  // useEffect untuk memuat data utama dan opsi jenis soal saat komponen di-mount atau ID berubah
  useEffect(() => {
    // Pastikan idPaket valid sebelum melakukan fetch
    if (idPaket) { 
      fetchData(1, pagination.per_page, filters);

      // Panggil fetchJenisSoalOptions hanya jika kedua ID (idTipeKonten dan idJenisSeleksi) valid
      if (idTipeKonten && idJenisSeleksi) {
        console.log("DEBUG: fetchJenisSoalOptions dipanggil dengan idTipeKonten dan idJenisSeleksi valid.");
        fetchJenisSoalOptions(idTipeKonten, idJenisSeleksi);
      } else {
        // Ini akan terpanggil jika id_tipe_konten atau id_jenis_seleksi tidak ada atau invalid di URL
        console.warn("DEBUG: ID Tipe Konten atau ID Jenis Seleksi tidak lengkap/valid dari URL. Memuat semua jenis soal atau tidak memfilter.");
        // Anda bisa memutuskan untuk:
        // 1. fetchJenisSoalOptions(); // Memuat semua jenis soal (jika API tidak error tanpa filter)
        // 2. Tidak melakukan apa-apa dan menunggu user mengoreksi URL
        // Untuk saat ini, kita akan memanggil tanpa filter untuk menghindari error, tapi idealnya URL harus lengkap.
        fetchJenisSoalOptions(); 
      }
    } else {
      setLoading(false);
      console.warn("DEBUG: idPaket tidak ditemukan atau invalid. Tidak memuat data.");
    }
  }, [idPaket, idTipeKonten, idJenisSeleksi]); // Dependensi ini akan memicu re-run jika ada perubahan pada ID

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = {
      ...filters,
      [name]: value
    };
    setFilters(newFilters);
    fetchData(1, pagination.per_page, newFilters);
  };

  const clearFilters = () => {
    const defaultFilters = {
      id_paket: "",
    };
    setFilters(defaultFilters);
    fetchData(1, pagination.per_page, defaultFilters);
  };

  // Konfigurasi validasi form menggunakan Formik dan Yup
  const validation = useFormik({
    enableReinitialize: true, 
    initialValues: {
      id_paket: isEdit ? (paketDetailTryout?.id_paket || "") : idPaket || "",
      id_jenis_soal: paketDetailTryout?.id_jenis_soal || "",
      jumlah_soal: paketDetailTryout?.jumlah_soal || "",
    },

    validationSchema: Yup.object({
      id_paket: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required("ID Paket wajib diisi"),
      id_jenis_soal: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required("Jenis Soal wajib diisi"),
      jumlah_soal: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .min(1, "Jumlah Soal minimal 1")
        .integer("Jumlah Soal harus bilangan bulat")
        .required("Jumlah Soal wajib diisi"),
    }),

    onSubmit: async (values) => {
      try {
        const payload = {
          id_paket: parseInt(values.id_paket, 10),
          id_jenis_soal: parseInt(values.id_jenis_soal, 10),
          jumlah_soal: parseInt(values.jumlah_soal, 10),
        };

        let response;
        if (isEdit) {
          response = await updatePaketDetailTryout(paketDetailTryout.id_detail_tryout, payload);
        } else {
          const createPayload = { ...payload, id_paket: idPaket }; 
          response = await createPaketDetailTryout(createPayload);
        }

        if (response.success) {
          toast.success(response.message || (isEdit ? "Detail Paket Tryout berhasil diperbarui" : "Detail Paket Tryout berhasil ditambahkan"));
          setModal(false);
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Operasi gagal.");
        }
      } catch (error) {
        console.error("Error in form submission:", error.message);
        if (error.response && error.response.data) {
            const apiResponse = error.response.data;
            if (apiResponse.errors) {
                Object.keys(apiResponse.errors).forEach(key => {
                    apiResponse.errors[key].forEach(msg => {
                        toast.error(`${key}: ${msg}`);
                    });
                });
            } else if (apiResponse.message) {
                toast.error(apiResponse.message);
            } else {
                toast.error("Terjadi kesalahan dari server dengan respons tidak dikenal.");
            }
        } else {
            toast.error(error.message);
        }
      }
    },
  });

  const openAddModal = () => {
    setPaketDetailTryout(null);
    setIsEdit(false);
    validation.resetForm(); 
    validation.setValues({ 
      id_paket: idPaket, 
      id_jenis_soal: "",
      jumlah_soal: "",
    });
    setModal(true);
  };

  const openEditModal = (data) => {
    setPaketDetailTryout(data);
    setIsEdit(true);
    validation.setValues({ 
      id_paket: data.id_paket || "",
      id_jenis_soal: data.id_jenis_soal || "",
      jumlah_soal: data.jumlah_soal || "",
    });
    setModal(true);
  };

  const onClickDelete = (data) => {
    setPaketDetailTryout(data);
    setDeleteModal(true);
  };

  // Table Column Definitions
  const columns = useMemo(
    () => [
      {
        header: "Nama Paket",
        accessorKey: "paket.nama_paket",
        enableColumnFilter: false,
        cell: (cellProps) => {
            return cellProps.row.original.paket ? cellProps.row.original.paket.nama_paket : "-";
        }
      },
       {
        header: "Jenis Soal",
        accessorKey: "jenis_soal.nama_jenis",
        enableColumnFilter: false,
        cell: (cellProps) => {
            const jenisSoal = cellProps.row.original.jenis_soal;
            return jenisSoal ? jenisSoal.nama_jenis : "-";
        }
      },
      { // Tambahkan kolom Jumlah Soal
        header: "Jumlah Soal",
        accessorKey: "jumlah_soal",
        enableColumnFilter: false,
        cell: (cellProps) => {
            return cellProps.getValue() || "-";
        }
      },
      {
        header: 'Created At',
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const rawDate = cellProps.getValue();
          if (rawDate && rawDate !== "0001-01-01T00:00:00Z") {
            const date = new Date(rawDate);
            if (!isNaN(date.getTime())) {
              return date.toISOString().split('T')[0];
            }
          }
          return "-";
        }
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        cell: (cellProps) => (
          <div className="hstack gap-2">
            <Link
              to="#"
              className="btn btn-sm btn-soft-info"
              onClick={() => openEditModal(cellProps.row.original)}
              id={`edittooltip-${cellProps.row.original.id_detail_tryout}`}
            >
              <i className="mdi mdi-pencil-outline" />
              <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id_detail_tryout}`}>
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="btn btn-sm btn-soft-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
              id={`deletetooltip-${cellProps.row.original.id_detail_tryout}`}
            >
              <i className="mdi mdi-delete-outline" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id_detail_tryout}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        )
      },
    ],
    [isEdit, paketDetailTryout] 
  );

  const CustomPagination = () => {
    const { page, last_page, total, per_page } = pagination;

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(last_page, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => fetchData(i, per_page, filters)}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      return pages;
    };

    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="text-muted">
          Menampilkan <span className="fw-semibold">{((page - 1) * per_page) + 1}</span> sampai{' '}
          <span className="fw-semibold">{Math.min(page * per_page, total)}</span> dari total{' '}
          <span className="fw-semibold">{total}</span> entri
        </div>

        <div className="d-flex align-items-center">
          <Pagination className="pagination pagination-rounded mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink
                previous
                onClick={() => page > 1 && fetchData(page - 1, per_page, filters)}
              >
                &lt;
              </PaginationLink>
            </PaginationItem>

            {getPageNumbers()}

            <PaginationItem disabled={page === last_page}>
              <PaginationLink
                next
                onClick={() => page < last_page && fetchData(page + 1, per_page, filters)}
              >
                &gt;
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleConfirmDelete}
        onCloseClick={handleCloseDeleteModal}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master Data" breadcrumbItem="Paket Detail Tryout" />
          {
            loading ? <Spinners setLoading={setLoading} />
              :
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody className="border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 card-title flex-grow-1">Daftar Paket Detail Tryout</h5>
                        <div className="d-flex align-items-center">
                          <Button color="primary" onClick={openAddModal}>
                            <i className="mdi mdi-plus me-1"></i>
                            Tambah Detail
                          </Button>
                        </div>
                      </div>
                    </CardBody>
                    <CardBody>
                      <h5 className="mb-3">Filter Paket Detail Tryout</h5>
                      <Row className="mb-3 align-items-end">
                        <Col md="2" className="d-flex align-items-end mb-3">
                          <Button color="danger" outline onClick={clearFilters} className="w-100">
                            Reset Filter
                          </Button>
                        </Col>
                      </Row>

                      <TableContainer
                        columns={columns}
                        data={data}
                        isGlobalFilter={false}
                        isPagination={false}
                        customPageSize={pagination.per_page}
                        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check data
                        no-footer dtr-inline mt-4 border-top"
                      />
                      <CustomPagination />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
          }

          {/* Modal for Add/Edit Paket Detail Tryout */}
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)} tag="h4">
              {!!isEdit ? "Edit Detail Paket Tryout" : `Tambah Detail untuk Paket ID: ${idPaket || '-'}`}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col md="12">
                    {/* Display Paket Name as plain text when editing */}
                    {isEdit ? (
                      <div className="mb-3">
                        <Label>Paket Terkait</Label>
                        <p className="form-control-static">
                          {paketDetailTryout?.paket?.nama_paket} (ID: {paketDetailTryout?.id_paket})
                        </p>
                        {/* Hidden input to send id_paket during update */}
                        <Input type="hidden" name="id_paket" value={validation.values.id_paket} />
                      </div>
                    ) : (
                      // Hide id_paket input when adding and use a hidden input
                      <Input type="hidden" name="id_paket" value={validation.values.id_paket} />
                    )}

                    <div className="mb-3">
                      <Label htmlFor="id_jenis_soal">Jenis Soal</Label>
                      <Input
                        name="id_jenis_soal"
                        type="select"
                        className="form-select"
                        id="id_jenis_soal"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.id_jenis_soal || ""}
                        invalid={!!(validation.touched.id_jenis_soal && validation.errors.id_jenis_soal)}
                        disabled={loadingJenisSoalOptions} // Disabled saat memuat opsi
                      >
                        <option value="">-- Pilih Jenis Soal --</option>
                        {loadingJenisSoalOptions ? (
                          <option disabled>Memuat data...</option> // Pesan saat memuat
                        ) : (
                          jenisSoalOptions.map((option) => (
                            <option key={option.id_jenis_soal} value={option.id_jenis_soal}>
                              {option.nama_jenis}
                            </option>
                          ))
                        )}
                      </Input>
                      <FormFeedback>{validation.errors.id_jenis_soal}</FormFeedback>
                    </div>

                    {/* Input untuk Jumlah Soal */}
                    <div className="mb-3">
                      <Label htmlFor="jumlah_soal">Jumlah Soal</Label>
                      <Input
                        name="jumlah_soal"
                        type="number"
                        placeholder="Masukkan jumlah soal"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.jumlah_soal || ""}
                        invalid={!!(validation.touched.jumlah_soal && validation.errors.jumlah_soal)}
                      />
                      <FormFeedback>{validation.errors.jumlah_soal}</FormFeedback>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button color="success" type="submit">
                        {isEdit ? "Update" : "Simpan"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
}

export default PaketDetailTryout;